









import { Vue, Component } from 'vue-property-decorator';
import { getRules } from '@/api/api';
import { getBaseinfo } from './api/index';
import { Banner } from '@/components';
import * as config from './config';
@Component({
  components: {
    Banner,
  },
})
export default class Rules extends Vue {
  options = config.OPTHINES;
  RuleData = '';
  baseInfo: object = {};
  created() {
    getBaseinfo().then((res: any) => (this.baseInfo = res.data));
    getRules(this.options.voteName).then(
      (res: any) => (this.RuleData = res.data),
    );
  }
}
